import { createGettext } from 'vue3-gettext';
import { Cookies } from 'quasar';
import fyzionTranslations from '../language/fyzion/translations.json';
import cortexTranslations from '../language/cortex/translations.json';
import mindTranslations from '../language/mind/translations.json';
import { ref } from 'vue';

const themeTranslations = {
  cortex: cortexTranslations,
  fyzion: fyzionTranslations,
  mind: mindTranslations,
};

const translations = themeTranslations[process.env.THEME] || fyzionTranslations;

const urlLang = new URLSearchParams(window.location.search).get('lang');
const storedLanguage = urlLang || Cookies.get('preferredLanguage');
const detectedLanguage = storedLanguage || navigator.language.slice(0, 2);

if (!urlLang && !Cookies.get('preferredLanguage')) {
  Cookies.set('preferredLanguage', detectedLanguage, {
    path: '/',
    expires: 730,
  });
}

export const currentLanguage = ref(detectedLanguage);

const gettext = createGettext({
  availableLanguages: {
    en: 'Anglicky',
    cs: 'Česky',
    sk: 'Slovensky',
    pl: 'Polsky',
  },
  defaultLanguage: currentLanguage.value,
  translations,
  silent: true,
});

export const setLanguage = (newLang: string): void => {
  Cookies.set('preferredLanguage', newLang, { path: '/', expires: 730 });
  currentLanguage.value = newLang;
};

export default gettext;
